const notice = () => {
  return `1.选手在【汉英双拼大会】注册信息并完成报名交费后（报名费入账为准），即报名成功。
2.报名成功后，选手即可获得：
  1）汉英双拼大会初赛/复赛等资格：汉英双拼大会初赛/复赛时间敬请关注CEBSB网站发布的信息和注册邮箱收到的SPBCN组委会邮件，请勿错过初赛/复赛；
  2）汉英双拼大会电子字库（报选组别字库+通识字库）：报名成功后即自动开通权限。
【退费规定】
1. 汉英双拼大会初选/复选报名：
  1）报名交费后15天内（含15天），如因特殊原因无法参赛，可向组委会申请退费，组委会将退还除平台收取的手续费之外的全部金额；
  2）报名交费超过15天或已参加所报名赛段的比赛，将无法办理退费。
  3）退款申请通过后，将于5-20个工作日内处理退回，请及时查收。
  4）如交费时使用了优惠券等任何优惠，则退款后优惠券自动失效。实际退款金额以该优惠规则为准。
2. 汉英双拼大会电子字库&练习题：
  付款成功后，将无法办理退费。
3.以上说明最终解释权归汉英双拼大会组委会所有。`
}

const policy = () => {
  return `欢迎您使用汉英双拼大会微信小程序服务！

  在您获得汉英双拼大会提供的微信小程序服务前，请您充分、审慎阅读本服务协议的全部内容（特别是以粗体下划线标注的内容），务必仔细审查、充分理解本协议的每一条款。如您不同意本协议的内容，或无法准确理解本协议任何条款的含义，请不要进行确认及后续操作。如果您对本协议有疑问的，您可通过汉英双拼大会客服渠道进行询问，其将向您进行说明。
  
  本协议的订立和变更
  
  1．本协议为北京聚知优国际教育投资管理有限公司（以下简称“汉英双拼大会”）与客户（以下简称“您”）就客户订购汉英双拼大会微信小程序并通过汉英双拼大会提供的软件系统使用微信小程序服务而订立的有效合约。除非你已阅读并接受本协议所有条款，否则你无权使用本服务。你对本服务的登录、查看、发布信息等行为即视为你已阅读并同意本协议的约束。你有违反本协议的任何行为时，汉英双拼大会有权依照违反情况，随时单方限制、中止或终止向你提供本服务，并有权追究你的相关责任。
  
  2．您理解并同意，汉英双拼大会有权在必要时修改本协议。你可以在相关服务页面查阅最新版本的协议。本协议变更后，如果你继续使用汉英双拼大会提供的微信小程序服务，即视为你已接受修改后的协议。如果你不接受修改后的协议，应当停止使用本服务。
  
  
  一、客户须知
  
  1.1 您需知晓，汉英双拼大会作为中立的技术服务提供方，微信小程序服务账号等配套服务是由腾讯独立运营并独立承担责任的服务平台。因您使用微信小程序服务或您在使用微信小程序服务过程中遭受的损失，请您和腾讯协商解决。对上述纠纷，汉英双拼大会有权进行协调，但汉英双拼大会并不保证协调取得的实际效果，汉英双拼大会不会对您进行赔偿或补偿。
  
  1.2 本协议项下服务是指汉英双拼大会软件系统调用微信小程序注册的API接口，通过该接口，您可以通过汉英双拼大会软件系统注册微信小程序并使用汉英双拼大会开发的微信小程序软件及相关服务。如您已经注册了微信小程序账号，在您开通本服务后可以直接登录您的微信小程序账号而使用汉英双拼大会开发的微信小程序软件及相关服务。
  
  1.3 您确认，由于汉英双拼大会调用小程序接口的原因会导致少数小程序功能功能无法实现，您不能以此来要求汉英双拼大会退款且汉英双拼大会对此不承担任何法律责任。
  
  
  二、信息保护
  
  2.1 您确认，您使用的微信小程序服务（包括但不限于服务的认证、审核、使用、账号安全）均由腾讯提供，除本协议外，您还需遵守腾讯就微信小程序服务使用事宜另行制定规范或规则的，包括但不限于《 腾讯服务协议》、《 腾讯微信软件许可及服务协议》、《 微信公众平台服务协议》、《 微信小程序平台服务条款》、《微信公众平台认证服务协议》等。
  
  2.2 您同意并授权汉英双拼大会将您的汉英双拼大会账户及您上传或提交的注册和使用微信小程序相关信息等传递给腾讯，用于腾讯为您提供服务。您提供相关信息我们将通过加密通道传递给腾讯。
  
  2.3 您在申请微信小程序服务时，您应按照汉英双拼大会和腾讯的要求和流程提交真实准确的相关资料，并通过汉英双拼大会和腾讯或其委托的第三方审核。如汉英双拼大会或腾讯公司发现您的注册信息不真实或不准确的，汉英双拼大会和腾讯公司均有权暂停或终止向您提供相关服务,由此产生的一切法律责任由您自行承担。
  
  2.4 汉英双拼大会有权查阅您的注册、交易数据及交易行为，如发现可能存在违反法律法规、本协议或汉英双拼大会相关规则的情形或其他任何问题，汉英双拼大会有权直接做出其认为合理的处理，包括但不限于删除相关信息，停止被协议项下的服务内容等。前述约定不代表汉英双拼大会应对您的行为承担任何连带责任，您应对此产生的法律责任独立负责。
  
  2.5 您同意，您使用本服务产生的相关数据，包括但不限于您在提交、操作中形成的数据及各类交易数据、您在使用微信小程序服务所形成的数据，在不损害您的合法权益的前提下，汉英双拼大会有权进行必要地收集、使用。
  
  2.6 对于您使用本服务所提供的信息，汉英双拼大会将会采取合理的措施进行保护。除法律法规规定的情形外，未经您许可汉英双拼大会不会向第三方公开、透露您的相关信息。尽管汉英双拼大会对您的信息保护做了极大的努力，但是仍然不能保证在现有的安全技术措施下，您的信息可能会因为不可抗力或非汉英双拼大会因素造成泄漏、窃取等，由此给您造成损失的，您同意汉英双拼大会可以免责。
  
  
  三、费用说明
  
  3.1 汉英双拼大会向您提供的服务付出了大量的成本，汉英双拼大会有权收取一定的技术服务费用，具体费用以相关交互界面中明确说明的费用为准。若汉英双拼大会后续调整收费政策，以交易进行时，您所触达的交互界面中明确说明的费用为准。如您是通过汉英双拼大会进行微信小程序申请账号的，其中微信小程序涉及的收费服务（包括微信公众平台认证服务、开通微信自有支付等功能）的将由腾讯单独向您收取，您应遵守腾讯的相关收费专项规则。
  
  3.2 汉英双拼大会有权视情况需要，在不同时期推出不同的优惠项目，比如设置抵用券或红包或返利等形式，您可根据汉英双拼大会设定的规则享有相应的优惠福利。任何优惠项目的推出，均非平台义务，您在任何时候均无权要求汉英双拼大会提供任何未正式上线汉英双拼大会平台的优惠政策或项目。
  
  3.3 汉英双拼大会可能根据实际需要对收费服务的收费标准、方式进行修改和变更。前述修改、变更或开始收费前，汉英双拼大会将在相应服务页面进行通知或公告。如果您不同意上述修改、变更或付费内容，则应停止使用该服务。
  
  3.4 您在使用微信小程序中产生的交易与结算，包括但不限于货款支付、系统查询、异常订单处理、第三方支付、服务费结算，汉英双拼大会仅为您使用微信小程序服务提供技术支持，本协议的签署不代表汉英双拼大会成为您与用户进行交易的参与者。汉英双拼大会不对基于前述服务而产生的任何行为担保、许可或向任何第三人承担共同责任。同时您需要遵守汉英双拼大会的相关规则，如您违反相应规则的汉英双拼大会有权下架您的商品及关闭部分功能或者禁止您使用相关服务。
  
  3.5 您在汉英双拼大会订购的微信小程序一旦订购成功，汉英双拼大会不支持退款处理。基于腾讯就微信小程序服务的认证及功能开通有相应规则与要求，您在使用本服务前应认真阅读并自觉遵守，由于您提交的信息不完整、不合规等原因使得您微信小程序认证及相关功能开通失败，从而导致您在汉英双拼大会订购的微信小程序服务软件无法使用的，汉英双拼大会亦不进行退款。
  
  3.6 您使用本服务的期限将根据您订购时的页面展示为准，服务期到期前请您及时进行续费，以免影响您的正常使用。如您到期未续费的，服务到期日您将无法使用本服务。因您未及时续费引发的服务不可用、暂停、终止或数据被清理等风险和损失均由您自行承担。
  
  
  四、法律责任
  
  4.1 你清楚知悉并理解，腾讯在本条款项下仅向您提供中立的技术支持服务，并且汉英双拼大会有权基于汉英双拼大会有序运营、健康发展等因素选择使用本服务的客户。
  
  4.2 您的小程序由您以其自身名义申请或享有合法的运营权利，任何由您的小程序所产生与任何第三方的纠纷、争议等，均由您独立承担全部责任，且与汉英双拼大会无关，汉英双拼大会不会、也不可能参与您的小程序的研发、运营等任何活动，也不会对你的小程序进行任何的修改、编辑或整理等。
  
  4.3 如有下列情形的，汉英双拼大会有权单方面解除本协议，终止向您提供服务：
  
  （1）您为了非法目的而使用本服务的；
  
  （2）您使用本服务损害汉英双拼大会或其他第三方合法权益的；
  
  （3）您违反法律法规或本协议约定或违反与腾讯的其他约定的；
  
  4.4 您理解并同意，除上述所述情形外，汉英双拼大会有权根据有关法律法规、市场风险及自身业务运营情况需要，随时终止向您提供本服务及接口的部分及全部，因此导致您无法使用服务或服务受到限制的，汉英双拼大会不构成违约，亦不承担任何法律责任。
  
  4.5 您停用本服务，或汉英双拼大会终止向您提供本协议项下的服务后，汉英双拼大会不再为您保留原账户中与之相关的任何信息。
  
  4.6 您理解并同意，因您违反本协议或相关服务条款的规定，导致或产生第三方主张的任何索赔、要求或损失，您应当独立承担责任；汉英双拼大会因此遭受损失（包括但不限于律师费、诉讼费、差旅费、担保费、保全费、鉴定费、公证费等）的，您也应当一并赔偿。
  
  
  五、其他
  
  5.1 本协议签订地为中华人民共和国广东省深圳市南山区。
  
  5.2 本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。
  
  5.3 因本协议引发的所有纠纷或争议，由双方友好协商解决；协商不成的，双方均同意将该等纠纷或争议提交本协议签订地有管辖权的人民法院诉讼解决
  
  `
}

export default {
  notice,
  policy
}
